<div class="flex justify-center">
    <tui-marker-icon
            class="tui-space_right-2 mb-8"
            mode="error"
            new
            size="xl"
            src="tuiIconAlertTriangle"
    ></tui-marker-icon>
</div>

<h1 class="text-secondary headline2 mb-4">
    {{prefixTranslation + 'title' | transloco}}
</h1>

<p class="text-primary-dark body1 mb-6">
    {{prefixTranslation + 'description' | transloco}}
</p>

<div class="flex space-x-7">
    <button (click)="close()" appearance="flat" class="flex-1 w-full" tuiButton>
        {{prefixTranslation + 'close-button' | transloco}}
    </button>

    <button (click)="confirmCancelBooking()" [showLoader]="isLoading" appearance="primary" class="flex-1 w-full"
            tuiButton>
        {{prefixTranslation + 'confirm-button' | transloco}}
    </button>
</div>
